import { Badge } from "@mui/material"
import { ReactNode } from "react"
import { useAppSelector } from "../../app/hooks"
import { commentsSelectors } from "./documentSlice"

export const AllCommentsCounter = (props: { contextGuid: string | null, sectionId: string, children: ReactNode }) => {
    const { contextGuid, sectionId } = props
    const comments = useAppSelector(state =>
        contextGuid !== null
            ? commentsSelectors.selectAll(state).filter(c => c.contextGuid === contextGuid && c.sectionGuid === sectionId)
            : commentsSelectors.selectAll(state).filter(c => c.sectionGuid === sectionId)
    )
    const allCount = comments.length
    const newCount = comments.filter(c => c.status === 'NEW').length

    return <Badge sx={{
        [`& > .MuiBadge-badge`]: {
            top: '8px',
        },
    }} color='info' badgeContent={allCount} showZero={false}>
        <Badge sx={{
            [`& > .MuiBadge-badge`]: {
                bottom: '8px',
            },
        }} color='error' anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} badgeContent={newCount} showZero={false}>
            {props.children}
        </Badge>
    </Badge>
}
